export default __webpack_public_path__ + "static/media/cp_geo_si.7ba15cc9.svg";